export const bowie_charlie_01_puppies = [
    {title:"Puppies", url:"litters/previous/bowie_charlie_2023/puppies"},
];